import React, { Suspense } from 'react';

const MessageLiveKitPanel = React.lazy(() => import('./MessageLiveKitPanel'));

export default function MessageLiveKitPanelLazy(props: any) {
  return (
    <Suspense
      fallback={
        <section
          style={{
            border: '1px solid rgba(96,165,250,0.28)',
            borderRadius: 16,
            padding: 12,
            margin: '8px 0',
            background: 'rgba(37,99,235,0.08)',
          }}
        >
          Loading LiveKit call tools…
        </section>
      }
    >
      <MessageLiveKitPanel {...props} />
    </Suspense>
  );
}
